import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import {
  FullHeightContainer,
  StyledPage,
} from '../../app/components/DashboardLayout/DashboardLayout.style';
import { GripsTableContainer } from '../containers/GripsTableContainer/GripsTableContainer';
import { PageHeader } from '../../app/components/DashboardLayout/PageHeader/PageHeader';

export const GripView: FC = () => {
  return (
    <StyledPage title="Grips">
      <FullHeightContainer maxWidth={false}>
        <Box mb={3}>
          <PageHeader title="Grips" />
        </Box>
        <Box
          flexDirection="column"
          height="100%"
          justifyContent="center"
          flex={1}
        >
          <GripsTableContainer />
        </Box>
      </FullHeightContainer>
    </StyledPage>
  );
};
